import { icons } from './constant';

// ==============================|| LOAN MENU ITEMS ||============================== //

const loan = {
	id: 'loan_master',
	title: 'Loan',
	type: 'collapse',
	icon: icons.IconLoan,
	children: [
		{
			id: 'fees',
			title: 'Fees',
			type: 'item',
			url: '/fees',
			icon: icons.WatchLaterOutlinedIcon,
			breadcrumbs: true,
		},
		// {
		//     id: 'document_types',
		//     title: 'Document Types',
		//     type: 'item',
		//     url: '/document-types',
		//     icon: icons.WatchLaterOutlinedIcon,
		//     breadcrumbs: true,
		// },
		// {
		//     id: 'status',
		//     title: 'Status',
		//     type: 'item',
		//     url: '/status',
		//     icon: icons.WatchLaterOutlinedIcon,
		//     breadcrumbs: true,
		// },
		// {
		//     id: 'loan-purpose',
		//     title: 'Loan-purpose',
		//     type: 'item',
		//     url: '/loanPurposes',
		//     icon: icons.WatchLaterOutlinedIcon,
		//     breadcrumbs: true,
		// },
		{
			id: 'templates',
			title: 'Templates',
			type: 'item',
			url: '/templates',
			icon: icons.WatchLaterOutlinedIcon,
			breadcrumbs: true,
		},
		// {
		//     id: 'languages',
		//     title: 'Languages',
		//     type: 'item',
		//     url: '/languages',
		//     icon: icons.LanguageIcon,
		//     breadcrumbs: true,
		// },
		// {
		//     id: 'bankAccountTypes',
		//     title: 'Bank Account Types',
		//     type: 'item',
		//     url: '/bank-account-types',
		//     icon: icons.SavingsOutlinedIcon,
		//     breadcrumbs: true,
		// },
		// {
		//     id: 'notificationTemplates',
		//     title: 'Notification Templates',
		//     type: 'item',
		//     url: '/notification-templates',
		//     icon: icons.LanguageIcon,
		//     breadcrumbs: true,
		// },
		{
			id: 'rejectionReasons',
			title: 'Rejection Reasons',
			type: 'item',
			url: '/rejection-reasons',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'stageStatus',
			title: 'Loan sub Status',
			type: 'item',
			url: '/stageStatus',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'programmes',
			title: 'Programmes',
			type: 'item',
			url: '/programmes',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'loanstatus',
			title: 'Loan status',
			type: 'item',
			url: '/loan-status',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'stampingAuthority',
			title: 'Stamping Authority',
			type: 'item',
			url: '/stamping-authority',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'restrictedProfiles',
			title: 'Restricted Profiles',
			type: 'item',
			url: '/restrictedProfiles',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'mandateEvents',
			title: 'Mandate Events',
			type: 'item',
			url: '/mandate-events',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'mitigants',
			title: 'Mitigant',
			type: 'item',
			url: '/mitigants',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'deviation',
			title: 'Deviation',
			type: 'item',
			url: '/deviation',
			icon: icons.SavingsOutlinedIcon,
			breadcrumbs: true,
		},
		{
			id: 'campaigns',
			title: 'Campaigns',
			type: 'item',
			url: '/campaigns',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'caseNoteTypes',
			title: 'Case Note Types',
			type: 'item',
			url: '/caseNoteTypes',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'loanPurposes',
			title: 'Loan Purposes',
			type: 'item',
			url: '/loanPurposes',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'decloneReasons',
			title: 'Decline Reasons',
			type: 'item',
			url: '/declineReasons',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'disbursementModes',
			title: 'Disbursement Modes',
			type: 'item',
			url: '/disbursementModes',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
		{
			id: 'esignDeactivateReasons',
			title: 'Esign Deactivate Reasons',
			type: 'item',
			url: '/esignDeactivateReasons',
			icon: icons.SavingsOutlinedIcon,
			breadCrumbs: true,
		},
	],
};

export default loan;
